import React from 'react';

const Loader: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="border-4 border-t-4 h-12 w-12 rounded-full animate-spin border-t-transparent border-blue-400"></div>
    </div>
  );
};

export default Loader;
